// Curated CPV codes most relevant to UK / EU defence procurement.
// Source: Eur-Lex CPV regulation 213/2008, filtered to defence-applicable codes.

export const CPV_CODES = [
  // Defence equipment (Division 35)
  { code: "35000000", label: "Security, fire-fighting, police and defence equipment" },
  { code: "35200000", label: "Police equipment" },
  { code: "35300000", label: "Weapons, ammunition and associated parts" },
  { code: "35311000", label: "Firearms" },
  { code: "35311100", label: "Pistols and revolvers" },
  { code: "35320000", label: "Light weapons, ammunition and associated parts" },
  { code: "35330000", label: "Ammunition" },
  { code: "35331000", label: "Munitions" },
  { code: "35340000", label: "Parts of firearms and ammunition" },
  { code: "35400000", label: "Military vehicles and associated parts" },
  { code: "35410000", label: "Armoured military vehicles" },
  { code: "35411000", label: "Battle tanks" },
  { code: "35412000", label: "Military combat vehicles" },
  { code: "35420000", label: "Parts of military vehicles" },
  { code: "35500000", label: "Warships and associated parts" },
  { code: "35510000", label: "Warships" },
  { code: "35511000", label: "Submarines" },
  { code: "35511100", label: "Surface warships" },
  { code: "35520000", label: "Parts of warships" },
  { code: "35600000", label: "Military aircraft, missiles and spacecraft" },
  { code: "35610000", label: "Military aircraft" },
  { code: "35611000", label: "Combat aircraft" },
  { code: "35611100", label: "Fighter aircraft" },
  { code: "35611200", label: "Bomber aircraft" },
  { code: "35612000", label: "Military helicopters" },
  { code: "35613000", label: "Unmanned aerial vehicles" },
  { code: "35613100", label: "Drones" },
  { code: "35620000", label: "Missiles" },
  { code: "35630000", label: "Military spacecraft" },
  { code: "35631000", label: "Military satellites" },
  { code: "35700000", label: "Military electronic systems" },
  { code: "35710000", label: "Command, control, communication and computer systems (C4I)" },
  { code: "35711000", label: "Command and control systems" },
  { code: "35712000", label: "Tactical command, control and communication systems" },
  { code: "35720000", label: "Military ISTAR (intelligence, surveillance, target acquisition, recon)" },
  { code: "35721000", label: "Electronic intelligence systems" },
  { code: "35722000", label: "Radar" },
  { code: "35723000", label: "Air-defence radar" },
  { code: "35730000", label: "Electronic warfare systems and countermeasures" },
  { code: "35740000", label: "Battle simulators" },
  { code: "35800000", label: "Individual and support equipment (military)" },
  { code: "35810000", label: "Individual equipment" },
  { code: "35811000", label: "Military uniforms" },
  { code: "35812000", label: "Combat uniforms" },
  { code: "35813000", label: "Military helmets" },
  { code: "35814000", label: "Gas masks" },
  { code: "35815000", label: "Bulletproof equipment" },
  { code: "35820000", label: "Support equipment (military)" },
  { code: "35900000", label: "Detection and analysis apparatus" },
  { code: "35910000", label: "Identification systems" },
  { code: "35920000", label: "Number plate recognition systems" },
  { code: "35930000", label: "Vessel identification systems" },

  // Aerospace / aviation (Division 34.7)
  { code: "34700000", label: "Aircraft and spacecraft" },
  { code: "34710000", label: "Helicopters, aeroplanes, spacecraft and other powered aircraft" },
  { code: "34711000", label: "Helicopters and aeroplanes" },
  { code: "34711100", label: "Aeroplanes" },
  { code: "34711300", label: "Pilotless aircraft" },
  { code: "34712000", label: "Spacecraft, satellites and launch vehicles" },
  { code: "34730000", label: "Parts of aircraft, spacecraft and helicopters" },
  { code: "34731000", label: "Aircraft parts" },
  { code: "34740000", label: "Apparatus for aircraft / training apparatus / simulators" },

  // Naval / shipbuilding (Division 34.5)
  { code: "34500000", label: "Ships and boats" },
  { code: "34510000", label: "Ships" },
  { code: "34511100", label: "Sea-going patrol vessels" },
  { code: "34513000", label: "Fishing, rescue and other special vessels" },
  { code: "34513300", label: "Rescue vessels" },
  { code: "34520000", label: "Boats" },
  { code: "34521000", label: "Special purpose boats" },

  // Land vehicles (Division 34.1)
  { code: "34100000", label: "Motor vehicles" },
  { code: "34110000", label: "Passenger cars" },
  { code: "34114000", label: "Specialist vehicles" },
  { code: "34114100", label: "Emergency vehicles" },
  { code: "34114200", label: "Police cars" },
  { code: "34140000", label: "Heavy-duty motor vehicles" },
  { code: "34144000", label: "Special-purpose motor vehicles" },

  // IT / software / cyber (very common in MOD)
  { code: "48000000", label: "Software package and information systems" },
  { code: "48100000", label: "Industry-specific software package" },
  { code: "48200000", label: "Networking, internet and intranet software" },
  { code: "48300000", label: "Document creation, drawing, imaging, scheduling software" },
  { code: "48400000", label: "Business transaction and personal business software" },
  { code: "48500000", label: "Communication and multimedia software" },
  { code: "48600000", label: "Database and operating software" },
  { code: "48700000", label: "Software package utilities" },
  { code: "48800000", label: "Information systems and servers" },
  { code: "48900000", label: "Miscellaneous software and computer systems" },
  { code: "72000000", label: "IT services: consulting, software development, internet and support" },
  { code: "72100000", label: "Hardware consultancy services" },
  { code: "72200000", label: "Software programming and consultancy services" },
  { code: "72210000", label: "Programming services of packaged software products" },
  { code: "72220000", label: "Systems and technical consultancy services" },
  { code: "72240000", label: "Systems analysis and programming services" },
  { code: "72250000", label: "System and support services" },
  { code: "72260000", label: "Software-related services" },
  { code: "72300000", label: "Data services" },
  { code: "72400000", label: "Internet services" },
  { code: "72500000", label: "Computer-related services" },
  { code: "72600000", label: "Computer support and consultancy services" },
  { code: "72700000", label: "Computer network services" },
  { code: "72800000", label: "Computer audit and testing services" },

  // Cyber / security services
  { code: "79710000", label: "Security services" },
  { code: "79711000", label: "Alarm-monitoring services" },
  { code: "79713000", label: "Guard services" },
  { code: "79714000", label: "Surveillance services" },
  { code: "79720000", label: "Investigation and security services" },

  // Telecoms / radio (Division 32)
  { code: "32000000", label: "Radio, television, communication, telecoms and related equipment" },
  { code: "32200000", label: "Transmission apparatus for radio-telephony / telegraphy / broadcasting / TV" },
  { code: "32210000", label: "Broadcasting equipment" },
  { code: "32230000", label: "Radio transmission apparatus" },
  { code: "32240000", label: "Television cameras" },
  { code: "32260000", label: "Data-transmission equipment" },
  { code: "32500000", label: "Telecommunications equipment and supplies" },
  { code: "32510000", label: "Wireless telecommunications system" },
  { code: "32520000", label: "Telecommunications cable and equipment" },
  { code: "32530000", label: "Satellite-related communications equipment" },
  { code: "32570000", label: "Communications equipment" },

  // Research & engineering
  { code: "73000000", label: "Research and development services and related consultancy" },
  { code: "73100000", label: "Research and experimental development services" },
  { code: "73200000", label: "Research and development consultancy services" },
  { code: "73300000", label: "Design and execution of research and development" },
  { code: "73400000", label: "R&D services on security and defence materials" },
  { code: "73410000", label: "Military research and technology" },
  { code: "73420000", label: "Pre-feasibility study and technological demonstration" },
  { code: "73430000", label: "Test and evaluation" },
  { code: "71000000", label: "Architectural, construction, engineering and inspection services" },
  { code: "71300000", label: "Engineering services" },
  { code: "71600000", label: "Technical testing, analysis and consultancy services" },

  // Training & simulation
  { code: "80500000", label: "Training services" },
  { code: "80510000", label: "Specialist training services" },
  { code: "80511000", label: "Staff training services" },
  { code: "80600000", label: "Training services in the field of defence and security materials" },
  { code: "80660000", label: "Training services for armed forces personnel" },

  // Medical
  { code: "33000000", label: "Medical equipments, pharmaceuticals and personal care products" },
  { code: "33100000", label: "Medical equipments" },
  { code: "33141000", label: "Disposable non-chemical medical consumables" },
  { code: "33735100", label: "Protective goggles" },

  // Logistics / fuels
  { code: "09000000", label: "Petroleum products, fuel, electricity and other sources of energy" },
  { code: "09100000", label: "Fuels" },
  { code: "09130000", label: "Petroleum and distillates" },
  { code: "60000000", label: "Transport services (excl. waste transport)" },
  { code: "60100000", label: "Road transport services" },
  { code: "60400000", label: "Air transport services" },
  { code: "60440000", label: "Aerial and related services" },
  { code: "60600000", label: "Water transport services" },
  { code: "63000000", label: "Supporting and auxiliary transport services; travel agencies" },

  // Maintenance / repair
  { code: "50000000", label: "Repair and maintenance services" },
  { code: "50100000", label: "Repair, maintenance and associated services of vehicles" },
  { code: "50200000", label: "Repair, maintenance and associated services (aircraft, railways, roads, marine)" },
  { code: "50211000", label: "Repair and maintenance services of aircraft" },
  { code: "50240000", label: "Repair and associated services related to marine equipment" },
  { code: "50241000", label: "Repair and maintenance services of ships" },
  { code: "50410000", label: "Repair and maintenance of measuring, testing, checking apparatus" },
  { code: "50532000", label: "Repair and maintenance of electrical machinery" },
  { code: "50800000", label: "Miscellaneous repair and maintenance services" },

  // Construction / facilities
  { code: "45000000", label: "Construction work" },
  { code: "45216000", label: "Construction work for buildings relating to law/order/emergency services and military" },
  { code: "45216200", label: "Construction work for military buildings and installations" },

  // Energy / batteries
  { code: "31000000", label: "Electrical machinery, apparatus, equipment and consumables; lighting" },
  { code: "31400000", label: "Accumulators, primary cells and primary batteries" },
  { code: "31430000", label: "Electric accumulators" },
  { code: "31600000", label: "Electrical equipment and apparatus" },

  // Optics / sensors
  { code: "38000000", label: "Laboratory, optical and precision equipments (excl. glasses)" },
  { code: "38500000", label: "Checking and testing apparatus" },
  { code: "38600000", label: "Optical instruments" },
  { code: "38635000", label: "Telescopes" },
  { code: "38636000", label: "Specialised optical instruments" },
  { code: "38640000", label: "Liquid-crystal devices, lasers and optical equipment" },
];

/** Returns up to `limit` codes matching the query (local curated list only).
 *  Kept for offline / fallback. For exhaustive search, call /api/cpv/search. */
export function searchCpv(query, { limit = 20, exclude = [] } = {}) {
  const q = (query || "").trim().toLowerCase();
  const excludeSet = new Set(exclude);
  if (!q) {
    return CPV_CODES.filter((c) => !excludeSet.has(c.code)).slice(0, limit);
  }
  const numQ = q.replace(/\D/g, "");
  const codeMatches = [];
  const labelMatches = [];
  for (const item of CPV_CODES) {
    if (excludeSet.has(item.code)) continue;
    if (numQ && item.code.startsWith(numQ)) {
      codeMatches.push(item);
    } else if (item.label.toLowerCase().includes(q)) {
      labelMatches.push(item);
    }
  }
  return [...codeMatches, ...labelMatches].slice(0, limit);
}

// Runtime cache of code → label so chips for codes outside the curated list
// (returned by /api/cpv/search) still render their human label.
const _runtimeLabels = new Map(CPV_CODES.map((c) => [c.code, c.label]));
export function cacheCpvLabels(items) {
  for (const it of items || []) {
    if (it && it.code && it.label) _runtimeLabels.set(it.code, it.label);
  }
}
export function findCpvLabel(code) {
  return _runtimeLabels.get(code) || null;
}
